import { Box, Typography, LinearProgress } from '@mui/material';

const styles = {
  percentageText: {
    fontWeight: '600',
    fontSize: '18px',
  },
  countText: {
    fontWeight: '400',
    fontSize: '16px',
  },
};

export default function SurveyLinearStat(props) {
  const {
    optionText,
    percentage,
    count,
    loadingResults,
    color = '#4FB5F9',
  } = props;
  return (
    <Box sx={{ width: '100%' }}>
      <Box display={'flex'} justifyContent="space-between" mt={2}>
        <Typography sx={styles.percentageText}>{optionText}</Typography>
        <Typography sx={styles.percentageText}>
          {percentage}% <span style={styles.countText}>({count})</span>
        </Typography>
      </Box>
      <LinearProgress
        variant={loadingResults ? 'indeterminate' : 'determinate'}
        value={percentage}
        sx={{
          height: '12px',
          borderRadius: '6px',
          backgroundColor: '#E0E0E0',
          '& .MuiLinearProgress-bar': {
            backgroundColor: color,
          },
        }}
      />
    </Box>
  );
}
